<template>
	<v-row>
		<v-col>
			<ui-box>
				<h5>Order {{ order.id }}</h5>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col>
						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Pass</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<a v-if="!allItemsTransferred"
									 :href="viewPassUrl(order.partner_user_id)" target="_blank">View
									Pass</a>
								<span v-else>All Items Transferred</span>
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Offer</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ order.offer.name }}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Status</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<v-badge
										class="ms-1"
										:color="order.status==='sold' ? 'success' : 'secondary'"
										:content="order.status"
										:value="order.status"
								></v-badge>
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Voucher</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ order.voucher }}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Purchased</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ getLocalDateTime(order.purchased_at, order.partner.timezone) }}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Created</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ getLocalDateTime(order.created_at, order.partner.timezone) }}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Updated</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ getLocalDateTime(order.updated_at, order.partner.timezone) }}
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</ui-box>

			<ui-box>
				<h6>Transaction Details</h6>
				<span class="grey--text text--darken-1 text-body-2">
				</span>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col>
						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Total Amount</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.price_paid ? order.price_paid : '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters v-if="order.points_paid > 0">
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Points</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ order.points_paid }}
							</v-col>
						</v-row>
						<v-divider class="my-2" v-if="order.points_paid > 0"></v-divider>

						<v-row no-gutters v-if="order.convenience_fee_paid > 0">
							<v-col align-self="start" cols="4" md="12">
								<span
										class="font-weight-bold text-body-2 text-md-h6">Convenience Fee</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{ order.convenience_fee_paid | twoDecimals }}
							</v-col>
						</v-row>
						<v-divider class="my-2" v-if="order.convenience_fee_paid > 0"></v-divider>

						<v-row no-gutters v-if="order.reseller_revenue > 0">
							<v-col align-self="start" cols="4" md="12">
								<span
										class="font-weight-bold text-body-2 text-md-h6">Reseller Revenue</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{ order.reseller_revenue | twoDecimals }}
							</v-col>
						</v-row>
						<v-divider class="my-2" v-if="order.reseller_revenue > 0"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Tax</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.tax_paid ? order.tax_paid : '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Card Type</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{
									extraData.transactions?.length > 0
											? saleTransaction?.card_type
											: ''
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">CC Number</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{
									extraData.transactions?.length > 0
											? saleTransaction?.last4
											: ''
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span
										class="font-weight-bold text-body-2 text-md-h6">CC Transaction Fee</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.payment_gateway_fee
											? order.payment_gateway_fee
											: '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">CC Bandwango Service Fee</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.service_fee_paid
											? order.service_fee_paid
											: '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Bandwango Management Fee</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.management_fee
											? order.management_fee
											: '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters v-if="order.refunded_amount > 0">
							<v-col align-self="start" cols="4" md="12">
								<span
										class="font-weight-bold text-body-2 text-md-h6">Refunded Amount</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ currencyPrefix }}{{
									order.refunded_amount
											? order.refunded_amount
											: '0.00' | twoDecimals
								}}
							</v-col>
						</v-row>
						<v-divider class="my-2" v-if="order.refunded_amount > 0"></v-divider>

						<v-divider class="my-4"></v-divider>
						<v-row no-gutters>
							<v-col cols="2">
								<v-row no-gutters>
									<v-col>
										<h6>Refunds</h6>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col>
										<v-switch
												v-if="isPaidOrder && (order.status === 'sold' || order.status === 'testing')"
												v-model="refundAll"
												class="mt-3"
												dense
												hide-details="auto"
												inset
												label="Refund All"
												@change="toggleSelectAllRefunding()"
										></v-switch>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col>
										<v-btn
												v-if="isPaidOrder && (order.status === 'sold' || order.status === 'testing')"
												class="ms-2 mt-2 rounded-lg"
												color="error"
												depressed
												:disabled="isRefundButtonDisabled()"
												@click="openRefundOrder()"
										>
											Refund ({{
												currencyPrefix
											}}{{ amountToRefund() || '0.00' | twoDecimals }})
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="10">
								<v-row>
									<v-col></v-col>
									<v-col>
										<small>Name</small>
									</v-col>
									<v-col>
										<small>Attribute</small>
									</v-col>
									<v-col>
										<small>Price</small>
									</v-col>
									<v-col>
										<small>Disable</small>
									</v-col>
									<v-col>
										<small>Refund Amount</small>
									</v-col>
									<v-col>
										<small>Refunded</small>
									</v-col>
								</v-row>
								<v-row
										v-for="(refundable, index) in refundables"
										:key="`refundable-${index}`"
								>
									<v-col>
										<v-checkbox
												v-if="canBeRefunded(refundable)"
												v-model="refundable.selectedForRefund"
												@change="onRefundedSelectionChange(refundable)"
												color="grey"
												dense
												:ripple="false"
												:disabled="refundAll"
												small
										></v-checkbox>
									</v-col>
									<v-col>
										<a target="_blank"
											 :href="viewAdminUrl(order.partner_id) + '/' + refundable.type + '/' + refundable.typeId">{{
												refundable.name
											}}</a>
										<br>
										<small>{{ refundable.voucher }}</small>
									</v-col>
									<v-col>
										{{ refundable.attribute }}
									</v-col>
									<v-col>
										{{ currencyPrefix }}{{ refundable.pricePaid || '0.00' | twoDecimals }}
									</v-col>
									<v-col>
										<template v-if="isPaidOrder">
											<v-checkbox
													@change="refundable.disabledOnRefund = $event"
													:input-value="refundable.disabledOnRefund || !!refundable.completedAt"
													color="grey"
													dense
													:ripple="false"
													:disabled="!!refundable.completedAt || !canBeRefunded(refundable) || !refundable.selectedForRefund || refundAll"
													small
											></v-checkbox>
										</template>
									</v-col>
									<v-col>
										<template v-if="isPaidOrder && refundable.selectedForRefund">
											<v-text-field
													v-if="canBeRefunded(refundable)"
													v-model.number="refundable.amountToRefund"
													class="rounded-lg"
													:disabled="refundAll"
													outlined
													:prefix="currencyPrefix + ' '"
													type="number"
													@input="validateRefundedMax(refundable)"
													@wheel.native.prevent
											></v-text-field>
											<small v-if="refundable.error"
														 class="error--text">{{ refundable.error }}</small>
										</template>
									</v-col>
									<v-col>
										<template v-if="isPaidOrder">
											-{{
												currencyPrefix
											}}{{ refundable.refundedAmount || '0.00' | twoDecimals }}
										</template>
									</v-col>
								</v-row>
								<v-row v-if="refundAll">
									<v-col></v-col>
									<v-col>
										Tax
									</v-col>
									<v-col></v-col>
									<v-col>
										{{ currencyPrefix }}{{ order.tax_paid | twoDecimals }}
									</v-col>
									<v-col></v-col>
									<v-col>
										{{ currencyPrefix }}{{ order.tax_paid | twoDecimals }}
									</v-col>
									<v-col></v-col>
								</v-row>
								<v-row v-if="refundAll">
									<v-col></v-col>
									<v-col>
										Convenience Fee
									</v-col>
									<v-col></v-col>
									<v-col>
										{{ currencyPrefix }}{{ order.convenience_fee_paid | twoDecimals }}
									</v-col>
									<v-col></v-col>
									<v-col>
										{{ currencyPrefix }}{{ order.convenience_fee_paid | twoDecimals }}
									</v-col>
									<v-col></v-col>
								</v-row>
							</v-col>
						</v-row>

						<template v-if="extraData.transactions?.length > 0">
							<v-divider class="my-4"></v-divider>
							<v-row no-gutters>
								<v-col cols="2">
									<h6>Transactions</h6>
								</v-col>
								<v-col cols="10">
									<bw-table aria-label="data-table" :headers="headersTransactions"
														:key="transactionsTableKey" :items="extraData.transactions"
														hide-search>
										<template v-slot:item.details="{ item: transaction }">
											<strong>Id:</strong> {{
												!transaction.transaction_id
														? ''
														: transaction.transaction_id
											}}<br/>
											<strong>Type:</strong> {{
												!transaction.type ? '' : transaction.type
											}}
										</template>
										<template v-slot:item.date="{ item: transaction }">
											{{
												getLocalDateTime(transaction.created_at, order.partner.timezone)
											}}
										</template>
										<template v-slot:item.amount="{ item: transaction }">
											{{ currencyPrefix }}{{ transaction.amount | twoDecimals }}
										</template>
										<template v-slot:item.status="{ item: transaction }">
											{{ transaction.status }}
										</template>
									</bw-table>
								</v-col>
							</v-row>
						</template>

					</v-col>
				</v-row>
			</ui-box>

			<ui-box>
				<h6>Customer</h6>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row>
					<v-col cols="auto">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="openUserEdit(order.order_customer, 'orderCustomer', 'Update Customer')"
						>
							Edit
						</v-btn>
					</v-col>
					<v-col cols="auto" v-if="order.status === 'sold' || order.status === 'testing'">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="sendEmail()"
						>
							Re-Send Email(s)
						</v-btn>
					</v-col>
					<v-col v-if="order.status === 'sold' || order.status === 'testing'">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="sendText()"
						>
							Re-Send Text
						</v-btn>
					</v-col>
				</v-row>
				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col>
						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Name</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<a target="_blank"
									 :href="customerViewUrl(order.order_customer.partner_user_id)">{{
										order.order_customer.name
									}}</a>
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Address</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								{{ order.order_customer.address ? order.order_customer.address : '' }}
								{{ order.order_customer.city ? order.order_customer.city : '' }}
								{{ order.order_customer.state ? order.order_customer.state : '' }}
								{{ order.order_customer.country ? order.order_customer.country : '' }}
								{{ order.order_customer.zip_code ? order.order_customer.zip_code : '' }}
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Phone</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<a href="javascript:void(0)"
									 :title="'Click to call ' + order.order_customer.name"
									 @click="callPhone(order.order_customer.partner_user_id, order.order_customer.phone)">{{
										order.order_customer.phone
									}}</a>
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>

						<v-row no-gutters v-if="order.order_customer.partner_user">
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">email</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<a :href="'mailto:' + order.order_customer.partner_user.email">{{
										order.order_customer.partner_user.email
									}}</a>
							</v-col>
						</v-row>

					</v-col>
				</v-row>
			</ui-box>

			<ui-box v-if="giftOrderDist">
				<h6>Gift Recipient</h6>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row>
					<v-col cols="auto">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="openUserEdit(giftOrderDist, 'orderDistributionGift', 'Update Gift Recipient')"
						>
							Edit
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="sendDistributionEmail(giftOrderDist)"
						>
							Re-Send Email(s)
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="info"
								depressed
								small
								@click="sendDistributionText(giftOrderDist)"
						>
							Re-Send Text
						</v-btn>
					</v-col>
					<v-col>
						<v-btn
								class="ms-2 mt-2 rounded-lg"
								color="error"
								depressed
								small
								@click="openOrderDistributionDelete(giftOrderDist.id, 'order')"
						>
							Delete
						</v-btn>
					</v-col>
				</v-row>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col>
						<v-row no-gutters>
							<v-col align-self="start" cols="4" md="12">
								<span class="font-weight-bold text-body-2 text-md-h6">Name</span>
							</v-col>
							<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
								<a target="_blank"
									 :href="customerViewUrl(giftOrderDist.partner_user_id)">{{
										giftOrderDist.name
									}}</a>
							</v-col>
						</v-row>
						<v-divider class="my-2"></v-divider>
					</v-col>
				</v-row>

				<v-row no-gutters>
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Phone</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						<a href="javascript:void(0)"
							 :title="'Click to call ' + giftOrderDist.name"
							 @click="callPhone(giftOrderDist.partner_user_id, giftOrderDist.phone)">{{
								giftOrderDist.phone
							}}</a>
					</v-col>
				</v-row>
				<v-divider class="my-2"></v-divider>

				<v-row no-gutters v-if="giftOrderDist.partner_user">
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">email</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						<a :href="'mailto:' + giftOrderDist.partner_user.email">{{
								giftOrderDist.partner_user.email
							}}</a>
					</v-col>
				</v-row>
				<v-divider class="my-2" v-if="giftOrderDist.partner_user"></v-divider>

				<v-row no-gutters v-if="giftOrderDist.delivered">
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Delivered</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						{{ getLocalDateTime(giftOrderDist.delivered, order.partner.timezone) }}
					</v-col>
				</v-row>
				<v-row no-gutters v-else-if="giftOrderDist.delivery_date">
					<v-col align-self="start" cols="4" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Scheduled</span>
					</v-col>
					<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
						{{ getLocalDateTime(giftOrderDist.delivery_date, order.partner.timezone) }}
					</v-col>
				</v-row>
				<v-row no-gutters v-else>
					<v-col align-self="start" cols="12" md="12">
						<span class="font-weight-bold text-body-2 text-md-h6">Self delivery</span>
					</v-col>
				</v-row>
			</ui-box>

			<ui-box>
				<h6>Notes</h6>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<template v-if="extraData.notes?.length > 0"
									v-for="(note, idx) in extraData.notes">
					<v-row :key="`note-${idx}`">
						<v-col cols="auto">
							<small>{{ note.userName }} - <span
									:title="getLocalDateTime(note.created_at, order.partner.timezone)">{{
									getLocalDateTime(note.created_at, order.partner.timezone)
								}}</span></small>
						</v-col>
						<v-col>
							<small><span v-html="note.note"></span></small>
						</v-col>
					</v-row>
					<v-divider v-if="idx < extraData.notes.length - 1"
										 class="mb-1 mt-1 opacity-90"></v-divider>
				</template>

				<v-row no-gutters>
					<v-col>
						<v-textarea
								v-model="newNote"
								auto-grow
								class="rounded-lg"
								label="New note"
								outlined
								rows="4"
						></v-textarea>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<v-btn
								class="ml-1"
								color="secondary"
								depressed
								small
								@click="addNewNote()"
						>
							<v-icon>
								mdi-plus-circle-outline
							</v-icon>
							<span>Add Note</span>
						</v-btn>
					</v-col>
				</v-row>
			</ui-box>

			<ui-box>
				<h6>Logs</h6>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<template v-if="logs.length > 0" v-for="(log, idx) in logs">
					<v-row :key="`log-${idx}`">
						<v-col cols="1">
							<v-badge
									class="mt-4"
									:color="logColor(log.level)"
									:content="log.level"
									:value="log.level"
							></v-badge>
						</v-col>
						<v-col cols="auto">
							<span
									:title="getLocalDateTime(log.created_at, order.partner.timezone, 'MMMM Do YYYY, HH:mm:ss')">{{
									getLocalDateTime(log.created_at, order.partner.timezone, 'MMMM Do YYYY, HH:mm:ss')
								}}</span>
						</v-col>
						<v-col cols="auto">
							{{ log.message }}
						</v-col>
					</v-row>
					<v-row>
						<div v-html="log.formattedData"></div>
					</v-row>
					<v-row no-gutters v-if="idx < logs.length - 1">
						<v-divider class="mb-1 mt-1 opacity-90"></v-divider>
					</v-row>
				</template>

			</ui-box>

			<v-row>
				<v-col>
					<v-btn
							class="mb-6 ms-2 mt-2 rounded-lg"
							color="info"
							depressed
							@click="showOrderItems = !showOrderItems"
					>
						{{ showOrderItems ? 'Hide Order Items' : 'Show Order Items' }}
					</v-btn>
				</v-col>
			</v-row>

			<ui-box v-if="showOrderItems">
				<h6>Order Items</h6>

				<v-divider class="mb-4 mt-4 opacity-80"></v-divider>

				<v-row no-gutters>
					<v-col>
						<template v-if="order.r_order_packages?.length > 0">
							<ui-box
									v-for="(order_package, idx) in order.r_order_packages"
									:key="`order_package-${idx}`"
							>
								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span
												class="font-weight-bold text-body-2 text-md-h6">Package Name</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										<a target="_blank"
											 :href="viewAdminUrl(order.partner_id) + '/package/' + order_package.package_id">{{
												packageName(order_package)
											}}</a>
									</v-col>
								</v-row>
							</ui-box>
						</template>

						<template v-if="order.r_order_deals?.length > 0">
							<ui-box
									v-for="(order_deal, idx) in order.r_order_deals"
									:key="`order_deal-${idx}`"
							>
								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span class="font-weight-bold text-body-2 text-md-h6">Pass Name</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										<a target="_blank"
											 :href="viewAdminUrl(order.partner_id) + '/deal/' + order_deal.deal_id">{{
												passName(order_deal)
											}}</a>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>

								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span class="font-weight-bold text-body-2 text-md-h6">Pass Type</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										{{ order_deal.deal?.template?.name || 'N/A' }}
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>

								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span
												class="font-weight-bold text-body-2 text-md-h6">Redemption Date</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										{{ redemptionPolicyDate(order, order_deal) }}
										<v-btn
												class="ml-1"
												color="secondary"
												depressed
												icon
												small
												@click="openRedemptionDatePolicyEdit(order_deal)"
										>
											<v-icon small>mdi-pencil-outline</v-icon>
										</v-btn>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>

								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span
												class="font-weight-bold text-body-2 text-md-h6">Refund Policy</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										{{ order_deal.deal?.refund_policy || 'N/A' }}
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>

								<v-row no-gutters>
									<v-col align-self="start" cols="4" md="12">
										<span
												class="font-weight-bold text-body-2 text-md-h6">Validation</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										{{ validationDesc(order_deal.deal?.check_in_validation) || 'N/A' }}
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>

								<v-row no-gutters v-if="transferredDeal(order_deal)">
									<v-col align-self="start" cols="4" md="12">
										<span
												class="font-weight-bold text-body-2 text-md-h6">Transferred</span>
									</v-col>
									<v-col align-self="start" class="pt-1 text-body-2" cols="8" md="12">
										<v-row>
											<v-col>
												<a target="_blank"
													 :href="customerViewUrl(transferredDeal(order_deal).partner_user_id)">{{
														transferredDeal(order_deal).name
													}}</a>
											</v-col>
											<v-col>
												<a href="javascript:void(0)"
													 :title="'Click to call ' + transferredDeal(order_deal).name"
													 @click="callPhone(transferredDeal(order_deal).partner_user_id, transferredDeal(order_deal).phone)">{{
														transferredDeal(order_deal).phone
													}}</a>
											</v-col>
											<v-col>
												<a :href="'mailto:' + transferredDeal(order_deal).partner_user.email">{{
														transferredDeal(order_deal).partner_user.email
													}}</a>
											</v-col>
											<v-col>
												<a :href="viewPassUrl(transferredDeal(order_deal).partner_user_id)"
													 target="_blank">
													View Pass
												</a>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="auto" v-if="order_deal.redemptions_made === 0">
												<v-btn
														class="ms-2 mt-2 rounded-lg"
														color="info"
														depressed
														small
														@click="openUserEdit(transferredDeal(order_deal), 'orderDistributionTransferDeal', 'Update Transfer Recipient')"
												>
													Edit
												</v-btn>
											</v-col>
											<v-col cols="auto">
												<v-btn
														class="ms-2 mt-2 rounded-lg"
														color="info"
														depressed
														small
														@click="sendDistributionEmail(transferredDeal(order_deal))"
												>
													Re-Send Email(s)
												</v-btn>
											</v-col>
											<v-col cols="auto">
												<v-btn
														class="ms-2 mt-2 rounded-lg"
														color="info"
														depressed
														small
														@click="sendDistributionText(transferredDeal(order_deal))"
												>
													Re-Send Text
												</v-btn>
											</v-col>
											<v-col>
												<v-btn
														class="ms-2 mt-2 rounded-lg"
														color="error"
														depressed
														small
														@click="openOrderDistributionDelete(transferredDeal(order_deal).id, 'deal')"
												>
													Delete
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-row no-gutters v-else-if="order_deal.deal.transferable">
									<v-col>
										<v-btn
												class="ms-2 mt-2 rounded-lg"
												color="info"
												depressed
												small
												@click="openOrderDistributionCreate(order_deal.id, 'deal', order_deal.deal.name)"
										>
											Transfer
										</v-btn>
									</v-col>
								</v-row>

								<template v-if="order_deal.order_products.length > 0">
									<v-divider class="my-4"></v-divider>
									<v-row no-gutters>
										<v-col cols="2">
											<h6>Products</h6>
										</v-col>
										<v-col cols="10">
											<bw-table aria-label="data-table" :headers="headersProducts"
																:key="idx" :items="order_deal.order_products"
																hide-search>
												<template v-slot:item.name="{ item: order_product }">
													<a target="_blank"
														 :href="viewAdminUrl(order.partner_id) + '/product/' + order_product.product.id">{{
															order_product.product.name
														}}</a>
												</template>
												<template v-slot:item.template="{ item: order_product }">
													{{ order_product.product.template?.name }}
												</template>
												<template v-slot:item.refund="{ item: order_product }">
													{{ order_product.product.refund_policy }}
												</template>
												<template v-slot:item.redemption="{ item: order_product }">
													{{ order_product.product.redemptions }}
												</template>
												<template v-slot:item.validation="{ item: order_product }">
													{{ order_product.product.redemption_validation }}
												</template>
												<template v-slot:item.actions="{ item: order_product }">
													<template v-if="order_product.redeemed">
														Redeemed: {{
															getLocalDate(order_product.redeemed, order.partner.timezone)
														}}
														<v-btn
																class="ms-2 mt-2 rounded-lg"
																color="info"
																depressed
																small
																@click="openRedeemProductEdit(order_product, false)"
														>
															Un-Redeem
														</v-btn>
													</template>
													<template
															v-else-if="order_product.product.redemptions !== 'none'">
														<v-btn
																class="ms-2 mt-2 rounded-lg"
																color="info"
																depressed
																small
																@click="openRedeemProductEdit(order_product, true)"
														>
															Redeem
														</v-btn>
													</template>
												</template>
											</bw-table>
										</v-col>
									</v-row>

								</template>

							</ui-box>
						</template>

						<template v-if="order.r_order_products?.length > 0">
							<ui-box>
								<v-row no-gutters>
									<v-col cols="2">
										<h6>Standalone <br> Products</h6>
									</v-col>
									<v-col cols="10">
										<bw-table aria-label="data-table" :headers="headersProducts"
															:items="order.r_order_products"
															:key="orderProductTableKey"
															hide-search>
											<template v-slot:item.name="{ item: order_product }">
												<a target="_blank"
													 :href="viewAdminUrl(order.partner_id) + '/product/' + order_product.product_id">{{
														standaloneProductName(order_product)
													}}</a>
												<template v-if="transferredProduct(order_product)">
													<v-row no-gutters>
														<v-col align-self="start" cols="4" md="12">
															<span class="font-weight-bold text-body-2 text-md-h6">Transferred</span>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col>
															<a target="_blank"
																 :href="customerViewUrl(transferredProduct(order_product).partner_user_id)">{{
																	transferredProduct(order_product).name
																}}</a>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col>
															<a href="javascript:void(0)"
																 :title="'Click to call ' + transferredProduct(order_product).name"
																 @click="callPhone(transferredProduct(order_product).partner_user_id, transferredProduct(order_product).phone)">{{
																	transferredProduct(order_product).phone
																}}</a>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col>
															<a :href="'mailto:' + transferredProduct(order_product).partner_user.email">{{
																	transferredProduct(order_product).partner_user.email
																}}</a>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col>
															<a :href="viewPassUrl(transferredProduct(order_product).partner_user_id)"
																 target="_blank">
																View Pass
															</a>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col cols="auto" v-if="!order_product.redeemed">
															<v-btn
																	class="ms-2 mt-2 rounded-lg"
																	color="info"
																	depressed
																	small
																	@click="openUserEdit(transferredProduct(order_product), 'orderDistributionTransferProduct', 'Update Transfer Recipient')"
															>
																Edit
															</v-btn>
														</v-col>
														<v-col cols="auto">
															<v-btn
																	class="ms-2 mt-2 rounded-lg"
																	color="info"
																	depressed
																	small
																	@click="sendDistributionEmail(transferredProduct(order_product))"
															>
																Re-Send Email(s)
															</v-btn>
														</v-col>
														<v-col cols="auto">
															<v-btn
																	class="ms-2 mt-2 rounded-lg"
																	color="info"
																	depressed
																	small
																	@click="sendDistributionText(transferredProduct(order_product))"
															>
																Re-Send Text
															</v-btn>
														</v-col>
														<v-col>
															<v-btn
																	class="ms-2 mt-2 rounded-lg"
																	color="error"
																	depressed
																	small
																	@click="openOrderDistributionDelete(transferredProduct(order_product).id, 'product')"
															>
																Delete
															</v-btn>
														</v-col>
													</v-row>
												</template>
												<template v-else-if="order_product.product.transferable">
													<v-row no-gutters>
														<v-col>
															<v-btn
																	class="ms-2 mt-2 rounded-lg"
																	color="info"
																	depressed
																	small
																	@click="openOrderDistributionCreate(order_product.id, 'product', order_product.product.name)"
															>
																Transfer
															</v-btn>
														</v-col>
													</v-row>
												</template>
											</template>
											<template v-slot:item.template="{ item: order_product }">
												{{ order_product.product.template?.name }}
											</template>
											<template v-slot:item.refund="{ item: order_product }">
												{{ order_product.product.refund_policy }}
											</template>
											<template v-slot:item.redemption="{ item: order_product }">
												{{ order_product.product.redemptions }}
											</template>
											<template v-slot:item.validation="{ item: order_product }">
												{{ order_product.product.redemption_validation }}
											</template>
											<template v-slot:item.actions="{ item: order_product }">
												<template v-if="order_product.redeemed">
													Redeemed: {{
														getLocalDate(order_product.redeemed, order.partner.timezone)
													}}
													<v-btn
															class="ms-2 mt-2 rounded-lg"
															color="info"
															depressed
															small
															@click="openRedeemProductEdit(order_product, false)"
													>
														Un-Redeem
													</v-btn>
												</template>
												<template
														v-else-if="order_product.product.redemptions !== 'none'">
													<v-btn
															class="ms-2 mt-2 rounded-lg"
															color="info"
															depressed
															small
															@click="openRedeemProductEdit(order_product, true)"
													>
														Redeem
													</v-btn>
												</template>
											</template>
										</bw-table>
									</v-col>
								</v-row>
							</ui-box>
						</template>

					</v-col>
				</v-row>
			</ui-box>

			<v-dialog v-model="dialog.redemptionDatePolicyEdit" content-class="rounded-xl"
								scrollable
								width="900px" :key="dialog.redemptionDatePolicyEditKey">
				<v-card class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>Redemption Date</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeRedemptionDatePolicyEdit()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text v-if="redemptionDatePolicyEdit">
						<v-form v-model="dialog.formRedemptionDatePolicyEditIsValid"
										ref="formRedemptionDatePolicyEdit">

							<v-row>
								<v-col>
									<bw-date-time-picker
											v-model="redemptionDatePolicyEdit.start_date"
											label="Starts"
											withTime
											:tz="order.partner.timezone"
									></bw-date-time-picker>
								</v-col>
								<v-col v-if="redemptionDatePolicyEdit.end_date">
									<bw-date-time-picker
											v-model="redemptionDatePolicyEdit.end_date"
											label="Ends"
											withTime
											:tz="order.partner.timezone"
									></bw-date-time-picker>
								</v-col>
								<v-col
										v-if="!redemptionDatePolicyEdit.end_date && redemptionDatePolicyEdit.expire_date">
									<bw-date-time-picker
											v-model="redemptionDatePolicyEdit.expire_date"
											label="Expires"
											withTime
											:tz="order.partner.timezone"
									></bw-date-time-picker>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions class="grey lighten-4">
						<v-spacer></v-spacer>
						<v-btn
								color="secondary"
								text
								@click="closeRedemptionDatePolicyEdit()"
						>
							Cancel
						</v-btn>
						<v-btn
								color="secondary"
								text
								:disabled="!dialog.formRedemptionDatePolicyEditIsValid"
								@click="updateRedemptionDatePolicy()"
						>
							Update
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialog.redeemProductEdit" content-class="rounded-xl" scrollable
								width="900px" :key="dialog.redeemProductEditKey">
				<v-card v-if="orderProductEdit" class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>Product Redemption</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeRedeemProductEdit()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form v-model="dialog.formRedeemProductEditIsValid"
										ref="formRedeemProductEdit">
							<v-row v-if="orderProductEdit.isRedeeming">
								<v-col>
									<bw-date-time-picker
											v-model="orderProductEdit.redeemedDate"
											label="Override Redemption Date"
											withTime
											:tz="order.partner.timezone"
									></bw-date-time-picker>
								</v-col>
							</v-row>
							<v-row v-else>
								<v-col>
									Redeemed on: {{
										getLocalDateTime(orderProductEdit.redeemedDate, order.partner.timezone)
									}}
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions class="grey lighten-4">
						<v-spacer></v-spacer>
						<v-btn
								color="secondary"
								text
								@click="closeRedeemProductEdit()"
						>
							Cancel
						</v-btn>
						<v-btn
								color="secondary"
								text
								:disabled="!dialog.formRedeemProductEditIsValid"
								@click="updateRedeemProduct()"
						>
							{{ orderProductEdit.isRedeeming ? 'Redeem' : 'Un-Redeem' }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog
					v-model="dialog.orderDistributionDelete" content-class="rounded-xl" persistent
					scrollable width="600px" :key="dialog.orderDistributionDeleteKey"
			>
				<v-card class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>Delete Distribution?</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeOrderDistributionDelete()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="text-body-2">
						<v-row>
							<v-col>
								Are you sure?
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<div class="align-center d-flex justify-space-between w-100">
							<span></span>
							<div class="d-flex justify-end">
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="closeOrderDistributionDelete()"
								>
									Cancel
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										@click="deleteDistribution()"
								>
									Confirm
								</v-btn>
							</div>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialog.orderDistributionCreate" content-class="rounded-xl"
								scrollable
								width="900px" :key="dialog.orderDistributionCreateKey">
				<v-card v-if="orderDistributionEdit" class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>Transfer</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeOrderDistributionCreate()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form v-model="dialog.formOrderDistributionCreateIsValid"
										ref="formOrderDistributionCreate">
							<v-row>
								<v-col>
									<v-text-field
											v-model="orderDistributionEdit.first_name"
											class="rounded-lg required"
											outlined
											label="First Name"
											persistent-hint
											type="text"
											:rules="rules.order_distribution_first_name"
									></v-text-field>
								</v-col>
								<v-col>
									<v-text-field
											v-model="orderDistributionEdit.last_name"
											class="rounded-lg required"
											outlined
											label="Last Name"
											persistent-hint
											type="text"
											:rules="rules.order_distribution_last_name"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
											v-model="orderDistributionEdit.email"
											class="rounded-lg required"
											outlined
											label="Email"
											persistent-hint
											type="email"
											:rules="rules.email"
									></v-text-field>
								</v-col>
								<v-col>
									<vue-tel-input-vuetify
											ref="phone"
											v-model="orderDistributionEdit.phone"
											append-icon="mdi-menu-down"
											class="rounded-lg"
											clearable
											:defaultCountry="'US'"
											hide-details="auto"
											label="Phone"
											mode="international"
											outlined
											:preferred-countries="['us', 'ca']"
											:rules="rules.phone"
											@input="phoneInputEvent"
											@keydown="phoneKeyEvent"
									></vue-tel-input-vuetify>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions class="grey lighten-4">
						<v-spacer></v-spacer>
						<v-btn
								color="secondary"
								text
								@click="closeOrderDistributionCreate()"
						>
							Cancel
						</v-btn>
						<v-btn
								color="secondary"
								text
								:disabled="!dialog.formOrderDistributionCreateIsValid"
								@click="createDistribution()"
						>
							Transfer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialog.userEdit" content-class="rounded-xl"
								scrollable
								width="900px" :key="dialog.userEditKey">
				<v-card v-if="userEdit" class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>{{ userEdit.title }}</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeUserEdit()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form v-model="dialog.formUserEditIsValid"
										ref="formUserEdit">
							<v-row>
								<v-col>
									<v-text-field
											v-model="userEdit.first_name"
											class="rounded-lg"
											outlined
											label="First Name"
											persistent-hint
											type="text"
									></v-text-field>
								</v-col>
								<v-col>
									<v-text-field
											v-model="userEdit.last_name"
											class="rounded-lg"
											outlined
											label="Last Name"
											persistent-hint
											type="text"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
											v-model="userEdit.email"
											class="rounded-lg required"
											outlined
											label="Email"
											persistent-hint
											type="email"
											:rules="rules.email"
									></v-text-field>
								</v-col>
								<v-col>
									<vue-tel-input-vuetify
											ref="phone"
											v-model="userEdit.phone"
											append-icon="mdi-menu-down"
											class="rounded-lg"
											clearable
											:defaultCountry="'US'"
											hide-details="auto"
											label="Phone"
											mode="international"
											outlined
											:preferred-countries="['us', 'ca']"
											:rules="rules.phone"
											@input="phoneInputEvent"
											@keydown="phoneKeyEvent"
									></vue-tel-input-vuetify>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions class="grey lighten-4">
						<v-spacer></v-spacer>
						<v-btn
								color="secondary"
								text
								@click="closeUserEdit()"
						>
							Cancel
						</v-btn>
						<v-btn
								color="secondary"
								text
								:disabled="!dialog.formUserEditIsValid"
								@click="updateUserEdit()"
						>
							Save
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog
					v-model="dialog.refundOrder" content-class="rounded-xl" persistent
					scrollable width="600px" :key="dialog.refundOrderKey"
			>
				<v-card class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between">
						<h5>Would like to refund this money?</h5>
						<v-btn
								class="mt-n1 me-n2"
								color="primary"
								depressed
								icon
								@click="closeRefundOrder()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="text-body-2">
						<v-row>
							<v-col>
								Are you sure?
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<div class="align-center d-flex justify-space-between w-100">
							<span></span>
							<div class="d-flex justify-end">
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="closeRefundOrder()"
								>
									Cancel
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										@click="refundItems()"
								>
									Confirm
								</v-btn>
							</div>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>

import { helpers } from '../../../helpers';

export default {
	name: "ViewOrder",
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		order: {
			type: Object,
			default: () => ({})
		},
		extraData: {
			type: Object,
			default: () => ({})
		},
	},
	data() {
		return {
			showOrderItems: false,
			headersProducts: [
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Name',
					value: 'name',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Type',
					value: 'template',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Refund Policy',
					value: 'refund',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Redemption Method',
					value: 'redemption',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Validation',
					value: 'validation',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '10%'
				},
			],
			headersTransactions: [
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Details',
					value: 'details',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Date',
					value: 'date',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Amount',
					value: 'amount',
					width: '10%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Status',
					value: 'status',
					width: '10%'
				},
			],
			dialog: {
				phoneIsValid: true,
				redemptionDatePolicyEdit: false,
				redemptionDatePolicyEditKey: 1000,
				formRedemptionDatePolicyEditIsValid: false,
				redeemProductEdit: false,
				redeemProductEditKey: 2000,
				formRedeemProductEditIsValid: false,
				orderDistributionDelete: false,
				orderDistributionDeleteKey: 3000,
				orderDistributionCreate: false,
				orderDistributionCreateKey: 4000,
				formOrderDistributionCreateIsValid: false,
				userEdit: false,
				userEditKey: 5000,
				formUserEditIsValid: false,
				refundOrder: false,
				refundOrderKey: 6000,
			},
			redemptionDatePolicyEdit: null,
			orderProductEdit: null,
			orderDistributionEdit: null,
			orderProductTableKey: 10000,
			transactionsTableKey: 10100,
			refundsTableKey: 10200,
			userEdit: null,
			refundAll: false,
			refundables: this.getRefundables(),
			newNote: null,
			rules: {
				redemption_start: [v => !!v || 'Redemption Start Date is required.'],
				redemption_end: [v => !!v || 'Redemption End Date is required.'],
				redemption_start_type: [v => !!v || 'Redemption start type is required.'],
				redemption_ends_amount: [v => !!v || 'Redemption ends amount is required.'],
				redemption_ends_type: [v => !!v || 'Redemption end type is required.'],
				redemption_ends_date: [v => !!v || 'Redemption end date is required.'],
				redemption_start_date: [v => !!v || 'Redemption start date is required.'],
				order_distribution_first_name: [v => !!v || 'First Name is required.'],
				order_distribution_last_name: [v => !!v || 'Last Name is required.'],
				email: [
					v => !!v || 'Email is required.',
					v => {
						const pattern =
								// eslint-disable-next-line max-len
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(v) || 'Please enter a valid e-mail.';
					}
				],
				phone: [
					() => this.dialog.phoneIsValid || 'Please enter a valid phone.'
				],
			},
			logDataMap: [
				{ key: 'status', map: 'statuses', link: 'id', value: 'name' },
				{ key: 'last_called', format: 'date' },
				{ key: 'last_status_change', format: 'date' },
			]
		}
	},
	methods: {
		getLocalDate(date, tz, format) {
			return helpers.getLocalDate(date, tz, format);
		},
		getLocalDateTime(dateTime, tz, format) {
			return helpers.getLocalDateTime(dateTime, tz, format);
		},
		customerViewUrl(customerId) {
			return helpers.getBaseUrl(this.partner, 'customers', 'main') + '/view-customer/' + customerId;
		},
		viewPassUrl(partnerUserId) {
			const forceTemplateV3 = this.extraData.viewAsV3 ? '&forceTemplate=v3' : '';
			return '/dashboard/viewPass/' + this.order.id + '?admin_partner_id=' + this.order.partner_id + '&partnerUserId=' + partnerUserId + forceTemplateV3;
		},
		viewAdminUrl(partnerId) {
			return '/admin/' + partnerId;
		},
		logColor(logLevel) {
			switch (logLevel) {
				case 'high':
					return 'error';
				case 'medium':
					return 'warning';
				case 'low':
					return 'yellow';
				case 'info':
					return 'info';
				default:
					return 'info';
			}
		},
		formatLog(log) {
			if(log.data) {
				log.formattedData = '<ul>';
				const data = JSON.parse(log.data);
				if(!data) {
					return log;
				}
				Object.keys(data).forEach((key) => {
					if(data[key]) {
						let map = this.logDataMap.find((x) => x.key === key);
						let oldValue, newValue;
						if(data[key].oldValue || data[key].newValue) {
							oldValue = _.isObject(data[key].oldValue)
									? '<pre>' + JSON.stringify(data[key].oldValue, undefined, 2) + '</pre>'
									: data[key].oldValue;
							newValue = _.isObject(data[key].newValue)
									? '<pre>' + JSON.stringify(data[key].newValue, undefined, 2) + '</pre>'
									: data[key].newValue;
						}
						else {
							newValue = _.isObject(data[key])
									? '<pre>' + JSON.stringify(data[key], undefined, 2) + '</pre>'
									: data[key];
						}
						if(map) {
							if(map.map) {
								let fOld = this.extraData[map.map].find((x) => x[map.link] === oldValue);
								let fNew = this.extraData[map.map].find((x) => x[map.link] === newValue);
								oldValue = fOld && fOld[map.value] || oldValue;
								newValue = fNew && fNew[map.value] || newValue;
							}

							if(map.format) {
								switch (map.format) {
									case 'date':
										oldValue = oldValue !== '0000-00-00 00:00:00'
												? this.getLocalDateTime(oldValue, this.order.partner.timezone)
												: oldValue;
										newValue = newValue !== '0000-00-00 00:00:00'
												? this.getLocalDateTime(newValue, this.order.partner.timezone)
												: newValue;
										break;
								}
							}
						}

						if(oldValue === undefined && newValue === undefined) return true; // no need to show the change
						if(oldValue && newValue === undefined) {
							newValue = "''";
						}

						log.formattedData += '<li>' + Bandwango.prettyId(map && map.newKey || key) + ' was ' + (oldValue
								? 'changed from <b/>' + oldValue + '</b>'
								: 'set') + ' to <b>' + newValue + '</b>.</li>';
					}
				});
				log.formattedData += '</ul>';
			}
			if(log.userName && !log.message.includes(log.userName)) {
				log.message = log.userName + ' made a modification: ' + log.message;
			}

			return log;
		},
		packageName(orderPackage) {
			let attrName = '';
			if(orderPackage.attribute?.name) {
				attrName = ' - ' + orderPackage.attribute.name;
			}
			return orderPackage.package.name + attrName;
		},
		passName(orderDeal) {
			return orderDeal.deal.name + this.addAttributeName(orderDeal) + this.addPackageName(orderDeal);
		},
		standaloneProductName(orderProduct) {
			return orderProduct.product.name + this.addAttributeName(orderProduct) + this.addPackageName(orderProduct);
		},
		addAttributeName(item) {
			return item.attribute?.name ? ' - ' + item.attribute.name : '';
		},
		addPackageName(item) {
			return item.package?.name ? ' [' + item.package?.name + ']' : '';
		},
		redemptionPolicyDate(order, orderDeal) {
			if(orderDeal.start_date && moment.utc(orderDeal.start_date).tz(order.partner.timezone) > new Date()) {
				return 'Available Starting: ' + this.getLocalDateTime(orderDeal.start_date, order.partner.timezone);
			}
			else if(orderDeal.end_date) {
				return 'Time Remaining: ' + (moment.utc(orderDeal.end_date).tz(order.partner.timezone) < new Date()
						? 'Expired'
						: countdown(moment.utc(orderDeal.end_date).tz(order.partner.timezone), null, countdown.DAYS | countdown.HOURS | countdown.MINUTES).toString());
			}
			else if(orderDeal.expire_date) {
				return 'Expires: ' + this.getLocalDateTime(orderDeal.expire_date, order.partner.timezone);
			}
			else {
				return "N/A";
			}
		},
		callPhone(partnerUserId, phone) {
			helpers.callPhone(partnerUserId, phone);
		},
		validationDesc(code) {
			switch (code) {
				case 'by_product':
					return 'By Product';
				case 'pin':
					return 'Venue Pin Number';
				case 'gps':
					return 'Device GPS';
				case 'gpsOrPin':
					return 'Device GPS or Pin Number';
				case 'qr':
					return 'QR Code Scan';
				case 'none':
					return 'None';
				default:
					return code;
			}
		},
		transferredDeal(orderDeal) {
			return (orderDeal.deal?.transferable
					&& orderDeal.order_distribution?.length > 0
					&& orderDeal.order_distribution[0]?.partner_user_id !== this.order.order_customer?.partner_user_id)
					? orderDeal.order_distribution[0]
					: null;
		},
		transferredProduct(orderProduct) {
			return (orderProduct.product?.transferable
					&& orderProduct.order_distribution?.length > 0
					&& orderProduct.order_distribution[0]?.partner_user_id !== this.order.order_customer?.partner_user_id)
					? orderProduct.order_distribution[0]
					: null;
		},
		sendEmail() {
			const url = `/orders/${this.order.id}/sendReceipt`;
			const data = {
				'admin_partner_id': this.order.partner_id
			};
			axios.post(url, data)
					.then(response => {
						window.EventBus.$emit('system-messages', [
							{
								message: 'Email(s) sent',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		sendText() {
			const url = `/orders/${this.order.id}/sendDashboardLink`;
			const data = {
				'admin_partner_id': this.order.partner_id
			};
			axios.post(url, data)
					.then(response => {
						window.EventBus.$emit('system-messages', [
							{
								message: 'Text sent',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		sendDistributionEmail(orderDistribution) {
			const url = `/orderDistributions/deliver/${orderDistribution.id}`;
			const data = {
				'admin_partner_id': this.order.partner_id,
				'method': 'email'
			};
			axios.put(url, data)
					.then(response => {
						window.EventBus.$emit('system-messages', [
							{
								message: 'Distribution email(s) sent',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		sendDistributionText(orderDistribution) {
			const url = `/orderDistributions/deliver/${orderDistribution.id}`;
			const data = {
				'admin_partner_id': this.order.partner_id,
				'method': 'text'
			};
			axios.put(url, data)
					.then(response => {
						window.EventBus.$emit('system-messages', [
							{
								message: 'Distribution text sent',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		openOrderDistributionDelete(orderDistributionId, type) {
			this.dialog.orderDistributionDeleteKey++;
			this.orderDistributionEdit = new OrderDistributionEdit();
			this.orderDistributionEdit.order_distribution_id = orderDistributionId;
			this.orderDistributionEdit.item_type = type;
			this.dialog.orderDistributionDelete = true;
		},
		closeOrderDistributionDelete() {
			this.orderDistributionEdit = new OrderDistributionEdit();
			this.dialog.orderDistributionDelete = false;
		},
		deleteDistribution() {
			const url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/delete-distribution/' + this.orderDistributionEdit.order_distribution_id;
			const data = { 'orderId': this.order.id, 'partnerId': this.order.partner_id };
			axios.put(url, data)
					.then(response => {
						const responseOrder = response.data.order;
						switch (this.orderDistributionEdit.item_type) {
							case 'order':
								this.$set(this.order, 'r_order_distribution', responseOrder.r_order_distribution);
								break;
							case 'deal':
								this.$set(this.order, 'r_order_deals', responseOrder.r_order_deals);
								break;
							case 'product':
								this.$set(this.order, 'r_order_products', responseOrder.r_order_products);
								this.orderProductTableKey++;
								break;
						}
						this.$set(this.extraData, 'logs', response.data.logs);
						this.closeOrderDistributionDelete();
						window.EventBus.$emit('system-messages', [
							{
								message: 'Distribution deleted successfully',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						this.closeOrderDistributionDelete();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		closeOrderDistributionCreate() {
			this.orderDistributionEdit = new OrderDistributionEdit();
			this.$refs.formOrderDistributionCreate.reset();
			this.dialog.orderDistributionCreate = false;
		},
		openOrderDistributionCreate(orderItemId, type, name) {
			this.dialog.orderDistributionCreateKey++;
			this.orderDistributionEdit = new OrderDistributionEdit();
			this.orderDistributionEdit.item_type = type;
			this.orderDistributionEdit.item_name = name;
			this.orderDistributionEdit.order_item_id = orderItemId;

			this.dialog.orderDistributionCreate = true;
		},
		createDistribution() {
			this.$refs.formOrderDistributionCreate.validate();
			if(!this.dialog.formOrderDistributionCreateIsValid) return;

			const url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/create-distribution/' + this.order.id;
			const data = {
				...this.orderDistributionEdit,
				'orderId': this.order.id,
				'partnerId': this.order.partner_id
			};
			axios.post(url, data)
					.then(response => {
						const responseOrder = response.data.order;
						switch (this.orderDistributionEdit.item_type) {
							case 'deal':
								this.$set(this.order, 'r_order_deals', responseOrder.r_order_deals);
								break;
							case 'product':
								this.$set(this.order, 'r_order_products', responseOrder.r_order_products);
								this.orderProductTableKey++;
								break;
						}
						this.$set(this.extraData, 'logs', response.data.logs);
						this.closeOrderDistributionCreate();
						window.EventBus.$emit('system-messages', [
							{
								message: 'Distribution created successfully',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						this.closeOrderDistributionCreate();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		openRedemptionDatePolicyEdit(orderDeal) {
			this.dialog.redemptionDatePolicyEditKey++;
			this.redemptionDatePolicyEdit = new RedemptionDatePolicyEdit();
			this.redemptionDatePolicyEdit.orderDealId = orderDeal.id;
			this.redemptionDatePolicyEdit.start_date = orderDeal.start_date;
			this.redemptionDatePolicyEdit.end_date = orderDeal.end_date;
			this.redemptionDatePolicyEdit.expire_date = orderDeal.expire_date;

			this.dialog.redemptionDatePolicyEdit = true;
		},
		closeRedemptionDatePolicyEdit() {
			this.$refs.formRedemptionDatePolicyEdit.reset();
			this.redemptionDatePolicyEdit = new RedemptionDatePolicyEdit();
			this.dialog.redemptionDatePolicyEdit = false;
		},
		updateRedemptionDatePolicy() {
			this.$refs.formRedemptionDatePolicyEdit.validate();
			if(!this.dialog.formRedemptionDatePolicyEditIsValid) return;

			const data = {
				'start_date': this.redemptionDatePolicyEdit.start_date,
				'end_date': this.redemptionDatePolicyEdit.end_date,
				'expire_date': this.redemptionDatePolicyEdit.expire_date,
				'partnerId': this.order.partner_id,
			}
			const url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/update-order-deal/' + this.redemptionDatePolicyEdit.orderDealId;
			axios.put(url, data)
					.then(response => {
						const orderDeal = this.order.r_order_deals.find(orderDeal => orderDeal.id === response.data.orderDeal.id);
						this.$set(orderDeal, 'start_date', response.data.orderDeal.start_date);
						this.$set(orderDeal, 'end_date', response.data.orderDeal.end_date);
						this.$set(orderDeal, 'expire_date', response.data.orderDeal.expire_date);

						this.closeRedemptionDatePolicyEdit();
						window.EventBus.$emit('system-messages', [
							{
								message: 'Redemption date updated',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.closeRedemptionDatePolicyEdit();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		openRedeemProductEdit(orderProduct, isRedeeming) {
			this.dialog.redeemProductEditKey++;
			this.orderProductEdit = new OrderProductEdit();
			this.orderProductEdit.orderProduct = orderProduct;
			this.orderProductEdit.redeemedDate = orderProduct.redeemed;
			this.orderProductEdit.isRedeeming = isRedeeming;

			this.dialog.redeemProductEdit = true;
		},
		closeRedeemProductEdit() {
			this.$refs.formRedeemProductEdit.reset();
			this.dialog.redeemProductEdit = false;
			this.orderProductEdit = new OrderProductEdit();
		},
		updateRedeemProduct() {
			this.$refs.formRedeemProductEdit.validate();
			if(!this.dialog.formRedeemProductEditIsValid) return;

			let data = null;
			let url = null;
			if(this.orderProductEdit.isRedeeming) {
				data = {
					'redeemed': this.orderProductEdit.redeemedDate,
					'device': 'admin',
					'partnerId': this.order.partner_id,
					'orderId': this.order.id
				}
				url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/redeem-order-product/' + this.orderProductEdit.orderProduct.id;
			}
			else {
				data = {
					'partnerId': this.order.partner_id,
					'orderId': this.order.id
				}
				url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/unredeem-order-product/' + this.orderProductEdit.orderProduct.id;
			}
			axios.post(url, data)
					.then(response => {
						this.$set(this.orderProductEdit.orderProduct, 'redeemed', response.data.orderProduct.redeemed);
						this.$set(this.extraData, 'logs', response.data.logs);
						this.closeRedeemProductEdit();
						window.EventBus.$emit('system-messages', [
							{
								message: response.data.message,
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						this.closeRedeemProductEdit();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		openUserEdit(user, type, title) {
			this.dialog.userEditKey++;
			this.userEdit = new UserEdit();
			this.userEdit.id = user.id;
			this.userEdit.type = type;
			this.userEdit.title = title;
			this.userEdit.first_name = user.first_name;
			this.userEdit.last_name = user.last_name;
			if(user.partner_user) {
				this.userEdit.email = user.partner_user.email;
			}
			this.userEdit.phone = user.phone;

			this.dialog.userEdit = true;
		},
		closeUserEdit() {
			this.$refs.formUserEdit.reset();
			this.userEdit = new UserEdit();
			this.dialog.userEdit = false;
		},
		updateUserEdit() {
			this.$refs.formUserEdit.validate();
			if(!this.dialog.formUserEditIsValid) return;

			const data = {
				'first_name': this.userEdit.first_name,
				'last_name': this.userEdit.last_name,
				'email': this.userEdit.email,
				'phone': this.userEdit.phone,
				'partnerId': this.order.partner_id,
				'orderId': this.order.id
			}
			let url;
			switch (this.userEdit.type) {
				case 'orderCustomer':
					url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/update-order-customer/' + this.userEdit.id;
					break;
				case 'orderDistributionGift':
				case 'orderDistributionTransferDeal':
				case 'orderDistributionTransferProduct':
					url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/update-order-distribution/' + this.userEdit.id;
					break;
			}
			axios.put(url, data)
					.then(response => {
						switch (this.userEdit.type) {
							case 'orderCustomer':
								this.$set(this.order, 'order_customer', response.data.orderCustomer);
								break;
							case 'orderDistributionGift':
								const orderDistributionIndex = this.order.r_order_distribution.findIndex(orderDistribution => orderDistribution.id === response.data.orderDistribution.id);
								this.$set(this.order.r_order_distribution, orderDistributionIndex, response.data.orderDistribution);
								break;
							case 'orderDistributionTransferDeal':
								const orderDealIndex = this.order.r_order_deals.findIndex(orderDeal => orderDeal.id === response.data.orderDistribution.order_item_id);
								const orderDealDistributionIndex = this.order.r_order_deals[orderDealIndex].order_distribution.findIndex(orderDistribution => orderDistribution.id === response.data.orderDistribution.id);
								this.$set(this.order.r_order_deals[orderDealIndex].order_distribution, orderDealDistributionIndex, response.data.orderDistribution);
								break;
							case 'orderDistributionTransferProduct':
								const orderProductIndex = this.order.r_order_products.findIndex(orderProduct => orderProduct.id === response.data.orderDistribution.order_item_id);
								const orderProductDistributionIndex = this.order.r_order_products[orderProductIndex].order_distribution.findIndex(orderDistribution => orderDistribution.id === response.data.orderDistribution.id);
								this.$set(this.order.r_order_products[orderProductIndex].order_distribution, orderProductDistributionIndex, response.data.orderDistribution);
								break;
						}

						this.$set(this.extraData, 'logs', response.data.logs);
						this.closeUserEdit();
						window.EventBus.$emit('system-messages', [
							{
								message: 'User updated',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						this.closeUserEdit();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		phoneInputEvent(formattedNumber, { valid }) {
			this.dialog.phoneIsValid = formattedNumber === '' || valid;
		},
		phoneKeyEvent(e) {
			const validCharsRegex = new RegExp(/^[0-9 +\-()]*$/);

			// Allow Control+V or Command+V for pasting
			const isPasteOperation = (e.key === 'v' || e.key === 'V') && (e.ctrlKey || e.metaKey);

			if(!validCharsRegex.test(e.key) && ![
				'ArrowLeft',
				'ArrowRight',
				'Backspace',
				'Delete',
				'Tab'
			].includes(e.key) && !isPasteOperation) {
				e.preventDefault();
			}
		},
		onRefundedSelectionChange(refundable) {
			if(refundable.selectedForRefund && refundable.disabledOnRefund === undefined) {
				refundable.disabledOnRefund = true;
			}
		},
		canBeRefunded(item) {
			if(item.hasOwnProperty('order_package_id') && !!item.order_package_id) return false;
			if(item.hasOwnProperty('order_deal_id') && !!item.order_deal_id) return false;
			return parseFloat(item.pricePaid) > parseFloat(item.refundedAmount) && (this.order.status === 'sold' || this.order.status === 'testing');
		},
		toggleSelectAllRefunding() {
			function toggleItem() {
				return (item) => {
					this.$set(item, 'selectedForRefund', this.refundAll);
					this.$set(item, 'amountToRefund', this.refundAll
							? item.pricePaid - item.refundedAmount
							: 0);
					this.$set(item, 'error', "");
					this.$set(item, 'disabledOnRefund', this.refundAll ? true : !!item.completedAt);
				};
			}

			this.refundables.filter(this.canBeRefunded).forEach(toggleItem.call(this))
		},
		selectForRefund() {
			function shouldSend() {
				return item => item.selectedForRefund && this.canBeRefunded(item) && item.amountToRefund > 0;
			}

			const refundableItem = item => ({
				id: item.itemId,
				refund: item.amountToRefund,
				complete: !!item.disabledOnRefund || !!item.completedAt,
				error: item.error,
			});

			const packages = this.refundables
					.filter(refundable => refundable.type === 'package')
					.filter(shouldSend.call(this))
					.map(refundableItem);
			const deals = this.refundables
					.filter(refundable => refundable.type === 'deal')
					.filter(shouldSend.call(this))
					.map(refundableItem);
			const products = this.refundables
					.filter(refundable => refundable.type === 'product')
					.filter(shouldSend.call(this))
					.map(refundableItem);

			return {
				packages,
				deals,
				products,
			}
		},
		isValid(item) {
			return item.error == null || item.error === ""
		},
		areSelectedValid() {
			const selected = this.selectForRefund();
			return selected.packages.every(this.isValid) &&
					selected.deals.every(this.isValid) &&
					selected.products.every(this.isValid);
		},
		amountToRefund() {
			const sumAmountToRefund = (acc, item) => acc + parseFloat(item.refund);
			const totalAmount = (collection) => collection.filter(this.isValid).reduce(sumAmountToRefund, 0);
			const extra = this.refundAll && ['sold', 'testing'].includes(this.order.status)
					? parseFloat(this.order.tax_paid) + parseFloat(this.order.convenience_fee_paid)
					: 0;
			const selected = this.selectForRefund();
			return totalAmount(selected.packages) +
					totalAmount(selected.deals) +
					totalAmount(selected.products) + extra;
		},
		isRefundButtonDisabled() {
			return !this.areSelectedValid() || ![
				'sold',
				'testing'
			].includes(this.order.status) || this.amountToRefund() === 0;
		},
		validateRefundedMax(refundable) {
			const error = refundable.amountToRefund > this.maxRefundableValue(refundable)
					? `The maximum refundable amount is ${this.currencyPrefix}${this.maxRefundableValue(refundable)}`
					: "";
			refundable.error = error;
			return error === "";
		},
		maxRefundableValue(refundable) {
			return refundable.pricePaid - refundable.refundedAmount;
		},
		openRefundOrder() {
			if(this.amountToRefund() === 0) return;
			this.dialog.refundOrderKey++;
			this.dialog.refundOrder = true;
		},
		closeRefundOrder() {
			this.dialog.refundOrder = false;
		},
		refundItems() {
			const data = {
				...(this.refundAll ? { refundCompleteOrder: true } : this.selectForRefund()),
				'partnerId': this.order.partner_id,
			}
			const url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/refund-payment/' + this.order.id;
			axios.post(url, data)
					.then(response => {
						this.$set(this.order, 'status', response.data.order.status);
						this.$set(this.order, 'updated_at', response.data.order.updated_at);
						this.$set(this.order, 'refunded_amount', response.data.order.refunded_amount);
						this.$set(this.extraData, 'transactions', response.data.extraData.transactions);
						this.transactionsTableKey++;
						this.$set(this.extraData, 'logs', response.data.extraData.logs);
						this.$set(this.order, 'r_order_packages', response.data.order.r_order_packages);
						this.$set(this.order, 'r_order_deals', response.data.order.r_order_deals);
						this.$set(this.order, 'r_order_products', response.data.order.r_order_products);
						this.orderProductTableKey++;
						this.$set(this, 'refundables', this.getRefundables());

						this.closeRefundOrder();
						window.EventBus.$emit('system-messages', [
							{
								message: 'Item(s) refunded successfully',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						this.closeRefundOrder();
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		},
		getRefundables() {
			const refundables = [];
			if(this.order.r_order_packages.length) {
				this.order.r_order_packages.forEach(orderPackage => {
					const refundable = new Refundable();
					refundable.itemId = orderPackage.id;
					refundable.name = orderPackage.package.name;
					refundable.type = 'package';
					refundable.typeId = orderPackage.package.id;
					refundable.voucher = orderPackage.voucher;
					refundable.isRefundable = this.canBeRefunded(orderPackage);
					refundable.attribute = orderPackage.attribute?.name || '';
					refundable.pricePaid = orderPackage.price_paid;
					refundable.refundedAmount = orderPackage.refunded_amount;
					refundable.completedAt = orderPackage.completed_at;
					refundables.push(refundable);
				});
			}
			if(this.order.r_order_deals.length) {
				this.order.r_order_deals.forEach(orderDeal => {
					if(!orderDeal.package_id) {
						const refundable = new Refundable();
						refundable.itemId = orderDeal.id;
						refundable.name = orderDeal.deal.name;
						refundable.type = 'deal';
						refundable.typeId = orderDeal.deal.id;
						refundable.voucher = orderDeal.voucher;
						refundable.isRefundable = this.canBeRefunded(orderDeal);
						refundable.attribute = orderDeal.attribute?.name || '';
						refundable.pricePaid = orderDeal.price_paid;
						refundable.refundedAmount = orderDeal.refunded_amount;
						refundable.completedAt = orderDeal.completed_at;
						refundables.push(refundable);
					}
				});
			}
			if(this.order.r_order_products.length) {
				this.order.r_order_products.forEach(orderProduct => {
					if(!orderProduct.package_id && !orderProduct.deal_id) {
						const refundable = new Refundable();
						refundable.itemId = orderProduct.id;
						refundable.name = orderProduct.product.name;
						refundable.type = 'product';
						refundable.typeId = orderProduct.product.id;
						refundable.voucher = orderProduct.voucher;
						refundable.isRefundable = this.canBeRefunded(orderProduct);
						refundable.attribute = orderProduct.attribute?.name || '';
						refundable.pricePaid = orderProduct.price_paid;
						refundable.refundedAmount = orderProduct.refunded_amount;
						refundable.completedAt = orderProduct.completed_at;
						refundables.push(refundable);
					}
				});
			}
			return refundables;
		},
		addNewNote() {
			if(!this.newNote || this.newNote === '') return;

			const data = {
				'note': this.newNote,
				'partnerId': this.order.partner_id,
			}
			const url = helpers.getBaseUrl(this.partner, 'customers', 'main') + '/create-order-note/' + this.order.id;
			axios.post(url, data)
					.then(response => {
						this.$set(this.extraData, 'notes', response.data.notes);
						this.$set(this, 'newNote', null);
						this.$set(this.extraData, 'logs', response.data.logs);

						window.EventBus.$emit('system-messages', [
							{
								message: 'Note created successfully',
								messageType: 'success',
								showOverlay: true
							}
						]);
					})
					.catch(error => {
						this.$set(this.extraData, 'logs', error.response.data.logs);
						window.EventBus.$emit('system-messages', [
							{ message: error.response.data.message, messageType: 'error' }
						]);
					});
		}
	},
	computed: {
		isPaidOrder() {
			return this.order.price_paid > 0;
		},
		currencyPrefix() {
			return this.order?.partner?.r_currency?.prefix || this.partner?.currencyPrefix || '$';
		},
		giftOrderDist() {
			return (this.order.r_order_distribution?.length > 0
					&& this.order.r_order_distribution[0]?.partner_user_id !== this.order.order_customer?.partner_user_id)
					? this.order.r_order_distribution[0]
					: null;
		},
		saleTransaction() {
			return this.extraData.transactions.find(transaction => transaction.type === 'sale');
		},
		allItemsTransferred() {
			let allItemsTransferred = true;

			this.order.r_order_deals.forEach(orderDeal => {
				if(orderDeal.partner_user_id === this.order.partner_user_id) {
					allItemsTransferred = false;
				}
			});

			this.order.r_order_products.forEach(orderProduct => {
				if(orderProduct.partner_user_id === this.order.partner_user_id) {
					allItemsTransferred = false;
				}
			});

			return allItemsTransferred;
		},
		logs() {
			if(this.extraData.logs) {
				return this.extraData.logs.map(x => this.formatLog(x));
			}
			else {
				return [];
			}
		}
	},
};

const isValid = item => !item.error;

function RedemptionDatePolicyEdit() {
	this.orderDealId = null;
	this.start_date = null;
	this.end_date = null;
	this.expire_date = null;
}

function OrderProductEdit() {
	this.orderProduct = null;
	this.redeemedDate = null;
	this.isRedeeming = null;
}

function OrderDistributionEdit() {
	this.item_type = null;
	this.item_name = null;
	this.order_distribution_id = null;
	this.order_item_id = null;
	this.distribution_type = 'transfer';
	this.first_name = null;
	this.last_name = null;
	this.email = null;
	this.phone = null;
	this.deliver = true;
}

function UserEdit() {
	this.type = null;
	this.title = null;
	this.id = null;
	this.first_name = null;
	this.last_name = null;
	this.email = null;
	this.phone = null;
}

function Refundable() {
	this.itemId = null;
	this.name = null;
	this.type = null;
	this.typeId = null;
	this.voucher = null;
	this.selectedForRefund = null;
	this.isRefundable = null;
	this.attribute = null;
	this.pricePaid = null;
	this.disabledOnRefund = false;
	this.amountToRefund = 0;
	this.refundedAmount = null;
	this.completedAt = null;
	this.error = "";
}

</script>
